import { render, staticRenderFns } from "./MultiBadges.vue?vue&type=template&id=111bc7ec&"
import script from "./MultiBadges.vue?vue&type=script&lang=ts&"
export * from "./MultiBadges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports